export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/d3-array/src/identity.js
// module id = ../../../../d3-array/src/identity.js
// module chunks = vendor